export const STACK_PACKS_DETAILS_CLEAR_STATE = "@p-stack-packs-details/CLEAR_STATE";

export const STACK_PACKS_DETAILS_SET_FIELD = "@p-stack-packs-details/SET_FIELD";
export const STACK_PACKS_DETAILS_INIT_FIELDS = "@p-stack-packs-details/INITIALIZE_FIELDS";

export const STACK_PACKS_PROVISION_START = "@e-stack-packs/PROVISION_START";
export const STACK_PACKS_PROVISION_SUCCESS = "@e-stack-packs/PROVISION_SUCCESS";
export const STACK_PACKS_PROVISION_ERROR = "@e-stack-packs/PROVISION_ERROR";

export const STACK_PACKS_DEPROVISION_START = "@e-stack-packs/DEPROVISION_START";
export const STACK_PACKS_DEPROVISION_SUCCESS = "@e-stack-packs/DEPROVISION_SUCCESS";
export const STACK_PACKS_DEPROVISION_ERROR = "@e-stack-packs/DEPROVISION_ERROR";

export const STACK_PACKS_START_STATUS_UPDATE_STREAM = "@e-stack-packs/START_STATUS_UPDATE_STREAM";
export const STACK_PACKS_STOP_STATUS_UPDATE_STREAM = "@e-stack-packs/STOP_STATUS_UPDATE_STREAM";
export const STACK_PACKS_UPDATE_CONFIGURATION = "@e-stack-packs/UPDATE_CONFIGURATION";

export const STACK_PACKS_ADD_CONFIGURATION = "@e-stack-packs/ADD_INSTANCE_CONFIGURATION";
